import { useRef, useState } from "react";

import { HiUserCircle } from "react-icons/hi2";
import { RxHamburgerMenu } from "react-icons/rx";
import { useLocation, useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import Logo from "@/assets/images/logo.png";
import Button from "@/components/Button";
import ConfirmModal from "@/components/Modal/ConfirmModal";
import {
  ADMIN_MAIN_URL,
  DASHBOARD_URL,
  HOME_MAIN_URL,
  MYPAGE_MAIN_URL,
  RESERVATION_MAIN_URL,
} from "@/constants/routes";
import useModal from "@/hooks/useModal";
import { useOutSideClick } from "@/hooks/useOutSideClick";
import useViewMode from "@/hooks/useViewMode";
import useLoginStore from "@/store/loginStore";
import useUserStore from "@/store/userStore";

type HeaderProps = {
  onOpen: () => void;
};

const Header = ({ onOpen }: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { logout } = useLoginStore();
  const [resetUserInfo] = useUserStore(
    useShallow(state => [state.resetUserInfo]),
  );
  
  const profileRef = useRef<HTMLDivElement>(null);
  const profileModal = useModal();
  const [alertMessage] = useState("정말 로그아웃하시겠습니까?");
  const confirmModal = useModal();

  const { effectiveStateCode, canAccessAdmin } = useViewMode();

  useOutSideClick(profileRef, () => profileModal.onClose());

  const spotOnLogout = () => {
    confirmModal.onOpen();
    // 유저 정보 지우기
    resetUserInfo();
    // 서비스 로그아웃
    logout();
  };

// 2025.05.15 수정 (기존) absolute right-0 flex h-auto w-auto flex-col items-center rounded-md border border-gray-middle bg-white shadow-sm
  return (
    <nav className="flex h-16 flex-row items-center justify-between border-b border-gray-light bg-white px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12">
      {!location.pathname.includes("/view") ? (
        <Button
          variant="custom"
          className="h-[45px] w-[96px]"
          onClick={() => navigate(DASHBOARD_URL)}
        >
          <img src={Logo} className="h-full w-full object-contain" />
        </Button>
      ) : (
        <Button variant="custom" className="h-[45px] w-[96px]">
          <img src={Logo} className="h-full w-full object-contain" />
        </Button>
      )}

      {!location.pathname.includes("/view") ? (
        <>
          <div className="hidden flex-row items-center gap-10 md:flex">
            {effectiveStateCode === "01" && (
              <Button
                variant="custom"
                className="text-gray-500 transition-all hover:[text-shadow:_0_1px_2px_rgba(0,0,0,0.3)]"
                onClick={() => navigate(DASHBOARD_URL)}
              >
                대시보드
              </Button>
            )}
            {effectiveStateCode === "01" && (
              <Button
                variant="custom"
                className="text-gray-500 transition-all hover:[text-shadow:_0_1px_2px_rgba(0,0,0,0.3)]"
                onClick={() => navigate(HOME_MAIN_URL)}
              >
                교회 일정
              </Button>
            )}
            {effectiveStateCode === "01" && (
              <Button
                variant="custom"
                className="text-gray-500 transition-all hover:[text-shadow:_0_1px_2px_rgba(0,0,0,0.3)]"
                onClick={() => navigate(RESERVATION_MAIN_URL)}
              >
                예약 요청
              </Button>
            )}
            {canAccessAdmin && (
              <Button
                variant="custom"
                className="text-gray-500 transition-all hover:[text-shadow:_0_1px_2px_rgba(0,0,0,0.3)]"
                onClick={() => navigate(ADMIN_MAIN_URL)}
              >
                통합관리
              </Button>
            )}
            <div ref={profileRef} className="relative">
              <Button
                onClick={profileModal.onToggle}
                variant="custom"
                className="text-gray-400"
              >
                <HiUserCircle size={40} />
              </Button>
              {profileModal.isOpen && (
                <div className="absolute right-0 top-full mt-2 z-[60] w-36 overflow-hidden rounded-lg border border-gray-200 bg-white py-1 shadow-lg">
                  <button
                    type="button"
                    onClick={() => navigate(MYPAGE_MAIN_URL)}
                    className="flex w-full items-center px-4 py-2.5 text-sm text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900"
                  >
                    마이페이지
                  </button>
                  <div className="mx-3 border-t border-gray-100" />
                  <button
                    type="button"
                    onClick={() => { profileModal.onClose(); confirmModal.onOpen(); }}
                    className="flex w-full items-center px-4 py-2.5 text-sm text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900"
                  >
                    로그아웃
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="flex md:hidden">
            <Button variant="custom" onClick={onOpen}>  
              <RxHamburgerMenu size={26} />
            </Button>
          </div>
          {confirmModal.isOpen && (
            <ConfirmModal
              title="로그아웃"
              onConfirm={spotOnLogout}
              onClose={confirmModal.onClose}
            >
              {alertMessage}
            </ConfirmModal>
          )}
        </>
      ) : (
        <></>
      )}
    </nav>
  );
};

export default Header;
